class CntrlPlusCartFlow {
  constructor() {
    const {
      customerLoggedIn,
      initialConsultationProductId,
      initialConsultCompleted,
    } = document.documentElement.dataset;
    initialConsultCompleted;

    this.customerLoggedIn = customerLoggedIn === "true";
    this.initialConsultCompleted = initialConsultCompleted === "true";
    this.initialConsultationProductId = initialConsultationProductId
      ? parseInt(initialConsultationProductId)
      : null;
    this.routes = window.theme.routes || {};
    this.paths = {
      base: `${this.routes.cart.base || "/cart"}.js`,
      add: `${this.routes.cart.add || "/cart/add"}.js`,
      change: `${this.routes.cart.change || "/cart/change"}.js`,
    };
    this.actions = {
      addItem: "add_item",
      changeItemQuantity: "change_item_quantity",
    };

    if (!this.initialConsultationProductId) return;

    if (this.customerLoggedIn && !this.initialConsultCompleted) {
      // Handle new items being added to the cart / edits within the cart. Keep in sync with consultation product.
      this.initCartEvents();
    }
  }

  initCartEvents() {
    document.addEventListener("cart:changed", (evt) => {
      this.handleCartChange(evt.detail.cartData);
    });
  }

  handleCartChange(cartData) {
    const { items } = cartData;

    if (!items.length) return;

    // Fires if Consult product is the only one in cart. This can occur when an item has been removed from the cart leaving the consult product.
    if (items.length === 1 && this.hasConsultationProduct(items)) {
      this.changeItemQuantity(this.initialConsultationProductId, "0");
    }

    if (!this.hasConsultationProduct(items) && !this.initialConsultCompleted) {
      this.addItemById(this.initialConsultationProductId);
    }
  }

  hasConsultationProduct(items) {
    return items.some((item) => item.id === this.initialConsultationProductId);
  }

  getCart() {
    return fetch(this.paths.base, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
  }

  addItemById(id) {
    const fetchData = {
      items: [
        {
          id: id,
          quantity: 1,
        },
      ],
    };

    return fetch(this.paths.add, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(fetchData),
    })
      .then((response) => response.json())
      .then(async (data) => {
        if (data.status === 422) {
          document.dispatchEvent(
            new CustomEvent("cart:error", {
              detail: { errorMessage: data.description },
            })
          );
        } else {
          // For some reason the add endpoint only returns the added item,
          // not the whole cart like other endpoints. We can fetch the cart and
          // insert items_added
          const cartData = await this.getCart();
          const combinedCartData = {
            ...cartData,
            items_added: data.items,
          };

          this._emitEvent(this.actions.addItem, combinedCartData);
        }
      });
  }

  changeItemQuantity(id, quantity) {
    const fetchData = {
      id: `${id}`,
      quantity,
    };

    return fetch(this.paths.change, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(fetchData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 422) {
          document.dispatchEvent(
            new CustomEvent("cart:error", {
              detail: { errorMessage: data.description },
            })
          );
        } else {
          this._emitEvent(this.actions.changeItemQuantity, data, {
            context: "cart_drawer",
            target: document,
          });
        }
      });
  }

  _emitEvent(action, cartData) {
    const target = document;

    const eventOptions = {
      detail: {
        cartData,
      },
      bubbles: true,
    };

    if (action === this.actions.addItem) {
      setTimeout(() => {
        target.dispatchEvent(new CustomEvent("cart:item-added", eventOptions));
      }, 1000);
    } else if (action === this.actions.changeItemQuantity) {
      target.dispatchEvent(new CustomEvent("cart:item-changed", eventOptions));
    }

    // Trigger a general cart change event on the document
    document.dispatchEvent(new CustomEvent("cart:changed", eventOptions));
  }
}

new CntrlPlusCartFlow();
